import type { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { MockConfigService } from './mock-config.service';
import { MOCK_REGISTRY } from './mock.registry';

export const mockInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const mockConfig = inject(MockConfigService);

  for (const [key, endpoint] of Object.entries(MOCK_REGISTRY)) {
    if (!req.url.includes(endpoint.urlPattern)) {
      continue;
    }

    const activeScenario = mockConfig.getActiveScenario(key);
    if (activeScenario && activeScenario in endpoint.scenarios) {
      const data = endpoint.scenarios[activeScenario];
      console.warn(`[MockInterceptor] ${endpoint.label} → ${activeScenario}`, data);
      return of(new HttpResponse({ status: 200, body: data }));
    }
  }

  return next(req);
};
